<template>
  <div class="login-wrapper">
    <a class="logo logo_type_c" v-if="isBrosaib"></a>
    <form class="login" v-if="!$route.params.jwt">
      <a-input
        v-model="auth.phone"
        placeholder="전화번호"
        @change="getMask('phone')"
        autocomplete="tel"
        class="ipt_type_1 email"
        :disabled="isLoading"
      />

      <div class="btn_wrapper">
        <a
          class="btn_type_1 btn_effect ef_type_2"
          v-on:click="submit"
          :disabled="isLoading"
        >{{ !isLoading ? '변경하기' : '변경 요청 중...' }}</a>

        <div class="login_btn_wrapper">
          <router-link to="/signin" class="a_type_1 text-center">로그인</router-link>&nbsp;
          <router-link to="/signup" class="a_type_1 text-center">회원가입</router-link>&nbsp;
          <router-link to="/uncle" class="a_type_1 text-center">사입삼촌</router-link>&nbsp;
          <router-link to="/admin" class="a_type_1 text-center">관리자</router-link>
        </div>
      </div>
    </form>
    <form class="login" v-else>
      <a-alert style="margin: 0.5em;" type="info" :message="`아이디: ${identity}`" banner />
      <a-input
        type="password"
        v-model="password"
        placeholder="비밀번호"
        autocomplete="new-password"
        class="ipt_type_1 email"
        :disabled="isLoading"
      />

      <a-input
        type="password"
        v-model="repeatPassword"
        placeholder="비밀번호 재입력"
        autocomplete="new-password"
        class="ipt_type_1 email"
        :disabled="isLoading"
      />

      <div class="btn_wrapper">
        <a
          class="btn_type_1 btn_effect ef_type_2"
          v-on:click="changePassword"
          :disabled="isLoading"
        >{{ !isLoading ? '변경하기' : '변경 요청 중...' }}</a>

        <div class="login_btn_wrapper">
          <router-link to="/signin" class="a_type_1 text-center">로그인</router-link>&nbsp;
          <router-link to="/signup" class="a_type_1 text-center">회원가입</router-link>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Axios from "axios";
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";

export default {
  name: "AuthSignin",
  data() {
    this.getMe();
    return {
      isLoading: false /* 로딩 상태 */,
      auth: {
        phone: "" /* 아이디 */
      },
      password: "",
      repeatPassword: "",
      identity: "로딩 중..."
    };
  },
  methods: {
    async submit() {
      this.isLoading = true;
      try {
        const { data } = await Axios.post(
          `${config.hostname}/v1/auth/forgot`,
          this.auth,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.$success({
                title: "비밀번호 재설정",
                content:
                  "해당 전화번호로 계정이 가입되어 있다면 비밀번호 찾기 주소가 보내집니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "오류가 발생하였습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "오류가 발생하였습니다.\n인터넷 상태를 확인해주세요."
        });
      }
      this.isLoading = false;
    },
    async getMe() {
      if (!this.$route.params.jwt) return;
      this.isLoading = true;
      try {
        const {
          data
        } = await Axios.get(
          `${config.hostname}/v1/auth/forgot/${this.$route.params.jwt}`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.identity = data.identity;
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "오류가 발생하였습니다."
              });
              this.$router.push("/find");
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "오류가 발생하였습니다.\n인터넷 상태를 확인해주세요."
        });
        this.$router.push("/find");
      }
      this.isLoading = false;
    },
    async changePassword() {
      if (!this.$route.params.jwt) return;
      if (this.password !== this.repeatPassword) {
        return config.alert.mixin({
          type: "error",
          title: "비밀번호가 서로 일치하지 않습니다."
        });
      }

      this.isLoading = true;
      try {
        const { data } = await Axios.post(
          `${config.hostname}/v1/auth/forgot/${this.$route.params.jwt}`,
          { password: this.password },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.$success({
                title: "비밀번호 재설정",
                content:
                  "비밀번호 재설정이 완료되었습니다. 등록하신 정보로 다시 로그인해주세요."
              });
              this.$router.push("/signin");
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "오류가 발생하였습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "오류가 발생하였습니다.\n인터넷 상태를 확인해주세요."
        });
      }
      this.isLoading = false;
    },
    getMask(type) {
      let num = this.auth[type].replace(/[^0-9]/g, "");

      let res = "";
      if (num.length < 3) {
        res = num;
      } else {
        if (num.substr(0, 2) == "02") {
          if (num.length <= 5) {
            //02-123-5678
            res = num.substr(0, 2) + "-" + num.substr(2, 3);
          } else if (num.length > 5 && num.length <= 9) {
            //02-123-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 3) + "-" + num.substr(5);
          } else if (num.length > 9) {
            //02-1234-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 4) + "-" + num.substr(6);
          }
        } else {
          if (num.length < 8) {
            res = num;
          } else if (num.length == 8) {
            res = num.substr(0, 4) + "-" + num.substr(4);
          } else if (num.length == 9) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length == 10) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length > 10) {
            //010-1234-5678
            res =
              num.substr(0, 3) + "-" + num.substr(3, 4) + "-" + num.substr(7);
          }
        }
      }

      this.auth[type] = res;
    }
  }
};
</script>